import React, { useState, useContext } from "react";

import Header from "../../components/template/estimate/Header";
import truck from "../../assets/images/estimate/move_truck.png";
import GetEstimate from "../../components/getEstimate/GetEstimate";
import MovePlannerContext from "../../context/move_planner/movePlanner";
// import navigationsLinks from "../../constants/navigation_links";

import ProgressBar from "../../components/template/ProgressBar";

import { useDispatch, useSelector } from "react-redux";
import { compareGeoCodes } from "../../components/common/validationFn";
import {
  getClientTimezone,
  getGeoCode,
  submitCustomerEnquiryAPI,
  // submitEstimate,
} from "../../adapters/estimate/estimateAdapters";
import { checkWithinCityBounds } from "../../components/common/GoogleAutoComplete";
import { useHistory } from "react-router-dom";
import {
  thunkSubmitMoveInfoForm,
  updateFormSubmitStatus,
  // loadMoveInfoFromURL,
} from "../../redux/reducers/move_info/moveInfoReducer";
// import { getDistanceGoogleAPI } from "../../adapters/estimate/estimateAdapters";
import { Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import config from "../../config/config";
import { useEffect } from "react";
import LoginModal from "../../components/inventory/Modal/LoginModal";
// import momentTimeZone from "moment-timezone";
const TruckImgContainer = () => {
  return (
    <div className="row align-items-center justify-content-center">
      <div className="col-12">
        <div className="img-container">
          <img src={truck} className="img-fluid" alt="" />
        </div>
      </div>
    </div>
  );
};
const MoveDetailsHeading = () => {
  return (
    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-12">
      <div className="row">
        <div className="col-12 highlight-heading">
          <h1>Move Details</h1>
          <p> Enter your moving details and property size </p>
        </div>
      </div>
    </div>
  );
};

export default function MoveDetails() {
  const context = useContext(MovePlannerContext);
  const { handleSubmit, setError } = context.estimateForm.useMoveInfoForm;

  const dispatch = useDispatch();
  const history = useHistory();
  const moveInfoState = useSelector((state) => state.moveInfo);
  //state
  const [moveType, setMoveType] = useState(moveInfoState.moveType);
  const [isCityListLoading, setIsCityListFetching] = useState(true);
  const [cityList, setCityList] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [moveInfoData, setMoveInfoData] = useState(null);
  // const [utmUrl, setUtmUrl] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);
  // const moveInfo = useSelector((state) => state.moveInfo);
  // const propertyInfo = useSelector((state) => state.propertyInfo);
  // const inventoryInfo = useSelector((state) => state.inventoryInfo);

  const onSubmit = async (data, event) => {
    //async validation
    dispatch(updateFormSubmitStatus({ status: true }));
    const fromAddress =
      data["city_type"] === "Within City"
        ? data["from_area_within"]
        : data["from_area_between"];
    const toAddress =
      data["city_type"] === "Within City"
        ? data["to_area_within"]
        : data["to_area_between"];
    //get geocode of from and to
    const fromGeoCode = await getGeoCode(fromAddress);
    const toGeoCode = await getGeoCode(toAddress);

    const checkResult = compareGeoCodes(fromGeoCode, toGeoCode);
    if (checkResult === false) {
      if (data["city_type"] === "Within City") {
        setError("from_area_within", { type: "isFromAndToSame" });
        setError("to_area_within", { type: "isFromAndToSame" });
      } else {
        // set for between
        setError("from_area_between", { type: "isFromAndToSame" });
        setError("to_area_between", { type: "isFromAndToSame" });
      }
      dispatch(updateFormSubmitStatus({ status: false }));
      return;
    }
    if (data["city_type"] === "Within City") {
      const selectedCityBounds = cityList.filter(
        (cityObj) => cityObj.city === data["select_city"]
      );
      const checkFromAddress = checkWithinCityBounds(
        selectedCityBounds[0].geocode.bounds,
        fromGeoCode
      );
      const checkToAddress = checkWithinCityBounds(
        selectedCityBounds[0].geocode.bounds,
        toGeoCode
      );
      if (checkFromAddress === false || checkToAddress === false) {
        if (checkFromAddress === false) {
          setError("from_area_within", { type: "isWithinCityBounds" });
        }
        if (checkToAddress === false) {
          setError("to_area_within", { type: "isWithinCityBounds" });
        }
        dispatch(updateFormSubmitStatus({ status: false }));
        return;
      }
    }
    let gotoPage = undefined;
    if (event !== undefined) {
      gotoPage = event.gotoPage;
    }
    const payload = { data, history, gotoPage: gotoPage };
    if (userInfo.loggedIn === false) {
      //check if user is already logged in
      setLoginModal(true);
      setMoveInfoData(payload);
      return;
    } else {
      dispatch(thunkSubmitMoveInfoForm(payload));
      return;
    }
  };
  // const collectLeadDetails = async () => {
  //   const getFlexibleStatus = (isFlexible) => {
  //     return isFlexible === true ? 1 : 0;
  //   };
  //   const userSessionData = JSON.parse(
  //     sessionStorage.getItem("userSessionData")
  //   );
  //   const moveInfo = JSON.parse(sessionStorage.getItem("move_info"));

  //   const userId = userSessionData.userId;
  //   const customerName = userSessionData.customerName;
  //   const clientTimezone = getClientTimezone();

  //   let movingDate = new Date(moveInfo.moving_date);
  //   movingDate = momentTimeZone
  //     .tz(movingDate, "UTC")
  //     .format("YYYY-MM-DD HH:mm:ss");
  //   const fromAddress = {
  //     firstName: customerName,
  //     lastName: "",
  //     fromAddress: "",
  //     fromLocality: "",
  //     fromCity: "",
  //     fromState: "",
  //     pincode: "",
  //   };

  //   const toAddress = {
  //     firstName: customerName,
  //     lastName: "",
  //     toAddress: "",
  //     toLocality: "",
  //     toCity: "",
  //     toState: "",
  //     pincode: "",
  //   };
  //   const body = {
  //     user_id: userId,
  //     city_type: moveInfo.city_type,
  //     select_city: moveInfo.select_city,
  //     moving_from: moveInfo.moving_from,
  //     moving_to: moveInfo.moving_to,
  //     moving_on: movingDate,
  //     distance: moveInfo.distance,
  //     duration: moveInfo.duration,
  //     property_size: moveInfo.property_size,
  //     move_date_flexible: getFlexibleStatus(moveInfo.move_date_flexible),
  //     old_floor_no: 0,
  //     new_floor_no: 0,
  //     old_elevator_availability: "No",
  //     packing_service: "Yes",
  //     new_elevator_availability: "No",
  //     unpacking_service: "No",
  //     old_parking_distance: 0,
  //     new_parking_distance: 0,
  //     old_house_additional_info: "",
  //     new_house_additional_info: "",
  //     items: "",
  //     total_items: 0,
  //     call_back: 0,
  //     service_type: "relocation",
  //     client_timezone: clientTimezone,
  //     from_address: JSON.stringify(fromAddress),
  //     to_address: JSON.stringify(toAddress),
  //     created_by: "customer",
  //     lead_stage: "lead_created",
  //     is_create_relocation: "0",
  //     days_of_storage: "",
  //     version: "v2",
  //     lead_source: "website",
  //   };

  //   const params = body;
  //   try {
  //     const response = await submitEstimate(params);
  //     if (
  //       response.data.meta.code === 200 &&
  //       response.data.meta.status === "OK"
  //     ) {
  //       console.log(response);
  //       const estimateId = response.data.data.estimate_id;
  //       const orderDetails = { orderId: estimateId, dateCreated: new Date() };
  //       sessionStorage.setItem("orderDetails", JSON.stringify(orderDetails));
  //       // dispatch(thunkClearEstimateData({ history }));
  //       // history.push(navigationsLinks.confirmation_page + "/" + estimateId);
  //       // setSubmitProgress(false);
  //       return { status: true };
  //     }
  //   } catch (e) {
  //     console.error(e);
  //     // setSubmitProgress(false);
  //     // setError({
  //     //   status: true,
  //     //   message: "OOP's! An Error Occurred, Please try again later.",
  //     // });
  //   }
  // };

  const utmUrlhandler = (url) => {
    const urlPathIndex = url.indexOf('urlpath=');
    if (urlPathIndex !== -1) {
      const substring = url.slice(urlPathIndex + 'urlpath='.length);
      // setUtmUrl(substring)
      sessionStorage.setItem("urlpath", JSON.stringify(substring));
      // alert(substring)
    }
  };

  useEffect(() => {
    utmUrlhandler(window.location.href.trim());
  }, []);

  useEffect(() => {
    try {
      if (cityList === null) {
        return;
      }
      //TODO: validate date check and type for each params.
      // const url = new URL(window.location.href);
      let param = new URLSearchParams(window.location.search);

      //link signature
      // w and b from within and between city
      // flexible 1 or 0
      // /packers-and-movers-relocation-services/get-quote?
      // pTsize=1 BHK&city=bangalore&from=koramangal, karnataka, bangalore&to=ejipura&mvOn=2020-11-20 10:10:10&mvType=w&flexible=1
      if (
        param.get("pTsize") !== null &&
        param.get("from") !== null &&
        param.get("to") !== null &&
        param.get("mvOn") !== null &&
        param.get("mvType") !== null &&
        param.get("city") !== null &&
        param.get("flexible") !== null
      ) {
        // setIsLoading(true);
        const propertySize = param.get("pTsize");
        const movingFrom = param.get("from");
        const movingTo = param.get("to");
        const movingOn = param.get("mvOn");
        const moveType =
          param.get("mvType") === "w" ? "Within City" : "Inter City";
        const selectCity = param.get("city");
        const isFlexible = param.get("flexible");
        const data = {
          city_type: moveType,
          property_size_within_city: propertySize,
          select_city: selectCity,
          from_area_within: movingFrom,
          to_area_within: movingTo,
          move_date_flexible_within: isFlexible,
          property_size_between_city: propertySize,
          from_area_between: movingFrom,
          to_area_between: movingTo,
          move_date_flexible_between: isFlexible,
          move_date_within_city: new Date(movingOn),
          move_date_between_city: new Date(movingOn),
        };
        onSubmit(data);
      }
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line
  }, [dispatch, cityList]);
  const JSX = (
    <React.Fragment>
      <Header
        currentPage="moveDetails"
        referenceToSubmit={(params) => {
          handleSubmit(onSubmit)(params);
        }}
      />
      <main className="get-estimate">
        {/* Mobile view progress bar */}
        <div className="container">
          <section className="progress-bar-section">
            <div className="row align-items-center justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-9">
                <ProgressBar
                  currentPage="moveDetails"
                  referenceToSubmit={(params) => {
                    handleSubmit(onSubmit)(params);
                  }}
                />
              </div>
            </div>
          </section>
        </div>
        <section className="container-fluid section-1 move-details-section">
          <div className="row align-items-center justify-content-center">
            <MoveDetailsHeading />
            <GetEstimate
              state={{
                moveType: moveType,
                setMoveType: setMoveType,
                isCityListLoading: isCityListLoading,
                setIsCityListFetching: setIsCityListFetching,
                cityList: cityList,
                setCityList: setCityList,
                hasError: hasError,
                setHasError: setHasError,
                onSubmit: onSubmit,
              }}
            />
          </div>
          <TruckImgContainer />
        </section>
        {loginModal === true && moveInfoData !== null && (
          <LoginModal
            isOpen={loginModal}
            isSkipInventory={true}
            additionalInfo={""}
            toggle={() => {
              setLoginModal(false);
              setMoveInfoData(null);
              dispatch(updateFormSubmitStatus({ status: false }));
            }}
            moveInfoData={moveInfoData}
            serviceType={"relocation"}
          />
        )}
      </main>
    </React.Fragment>
  );
  return JSX;
}

export function CustomerEnquiryForm(props) {
  const [open, setOpen] = useState(false);
  const { errors, register, handleSubmit } = useForm();
  const [status, setStatus] = useState("none");
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  useEffect(() => {
    const timer = setTimeout(
      function () {
        if (getCookie("leadModalSubmitted") !== "") {
          return;
        }
        setOpen(true);
      },
      config.leadModalDelay !== undefined ? config.leadModalDelay : 7000
    );
    return () => clearTimeout(timer);
  }, []);
  const onSubmit = async (data) => {
    console.log(data);
    const body = {
      email: data.email,
      name: data.name,
      mobile_number: data.phone,
      service_type: data.service_type,
      client_timezone: getClientTimezone(),
    };
    setStatus("in-progress");
    try {
      const result = await submitCustomerEnquiryAPI(body);
      if (result.status === 200) {
        setStatus("none");
        if (result.data.status === "success") {
          document.cookie = "leadModalSubmitted=true;path=/";

          window.location.href =
            config.customerPortal +
            `home/enquiry_confirmation?service_type=${body.service_type}&order_id=${result.data.data.order_id}`;
          return;
        }
      } else {
        setStatus("failed");
        console.error(result);
      }
    } catch (e) {
      console.error(e);
      setStatus("failed");
    }
  };
  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(false)}
      size={"lg"}
      centered={true}
    >
      <ModalBody>
        <div class="exit-btn text-right">
          <button
            class="clear-btn-style"
            data-dismiss="modal"
            onClick={() => setOpen(false)}
          >
            {" "}
            <img
              src={config.customerPortal + "assets/images/emojis/exit.png"}
              alt="exit"
            />{" "}
          </button>
        </div>
        <div className="form-container container-fluid">
          <div className="row ">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <img
                className="d-none d-lg-block"
                alt="side banner"
                src={
                  config.customerPortal +
                  "includes/img/customerDashboard/Rating.png"
                }
                style={{ width: "22rem" }}
              />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <form
                onSubmit={handleSubmit(onSubmit)}
                method="POST"
                className="form"
                autocomplete="off"
              >
                {status === "failed" && (
                  <div className="contact_us_status"> An error occurred </div>
                )}

                <div className="customer-enquiry-form">
                  <h2 style={{ fontSize: "1.875rem" }}>
                    {" "}
                    Help us to ease your Shifting!{" "}
                  </h2>
                  <h3 class="mb-4 text-active">
                    Fill in the details to get Flat 10% off
                  </h3>

                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: true,
                        validate: {
                          validName: (value) => /^[a-z" "]*$/i.test(value),
                          minLength: (value) =>
                            value.length < 3 ? false : true,
                          maxLength: (value) =>
                            value.length > 50 ? false : true,
                          morethan2spaces: (value) => !/\s{2,}/.test(value),
                        },
                      })}
                      name="name"
                      id="name"
                      placeholder="Your Name"
                    />
                    <span
                      className={`error-text ${errors.name ? "d-inline" : "d-none"
                        }`}
                    >
                      {errors.name &&
                        errors.name.type === "required" &&
                        "Required."}
                      {errors.name &&
                        errors.name.type === "validName" &&
                        "Please enter only alphabets."}
                      {errors.name &&
                        errors.name.type === "morethan2spaces" &&
                        "Consecutive whitespaces is not allowed."}
                      {errors.name &&
                        errors.name.type === "maxLength" &&
                        "Maximum character allowed is 50."}
                      {errors.name &&
                        errors.name.type === "minLength" &&
                        "Maximum 3 characters required."}
                    </span>
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      ref={register({
                        required: true,
                        validate: {
                          validEmail: (value) => {
                            return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                              value
                            );
                            // return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                          },
                          maxLength: (value) =>
                            value.length > 50 ? false : true,
                        },
                      })}
                      name="email"
                      id="email"
                      placeholder="Mail Id"
                    />
                    <span
                      className={`error-text ${errors.email ? "d-inline" : "d-none"
                        }`}
                    >
                      {errors.email &&
                        errors.email.type === "required" &&
                        "Required."}
                      {errors.email &&
                        errors.email.type === "validEmail" &&
                        "Please enter a valid email address."}
                      {errors.email &&
                        errors.email.type === "maxLength" &&
                        "Maximum characters allowed is 50."}
                    </span>
                  </div>
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      ref={register({
                        required: true,
                        validate: {
                          numberOnly: (value) => {
                            return /^[0-9]*$/i.test(value);
                          },
                          phoneLength: (value) => {
                            return value.length === 10 ? true : false;
                          },
                        },
                      })}
                      name="phone"
                      id="phone"
                      placeholder="Mobile No"
                    />

                    <span
                      className={`error-text ${errors.phone ? "d-inline" : "d-none"
                        }`}
                    >
                      {errors.phone &&
                        errors.phone.type === "required" &&
                        "Required."}
                      {errors.phone &&
                        errors.phone.type === "numberOnly" &&
                        "Please enter only number."}
                      {errors.phone &&
                        errors.phone.type === "phoneLength" &&
                        "Please enter 10 digit phone number."}
                    </span>
                  </div>
                  {/* <input
                    type="hidden"
                    id="client_timezone"
                    name="client_timezone"
                    value=""
                  /> */}
                  <div className="form-group mb-4">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        className="custom-control-input"
                        id="relocation_lead"
                        ref={register({ required: true })}
                        name="service_type"
                        // defaultChecked={true}
                        value="relocation"
                      />
                      <label
                        className="custom-control-label"
                        for="relocation_lead"
                      >
                        {" "}
                        Relocation{" "}
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        className="custom-control-input"
                        id="storage_lead"
                        ref={register({ required: true })}
                        name="service_type"
                        value="storage"
                      />
                      <label
                        className="custom-control-label"
                        for="storage_lead"
                      >
                        {" "}
                        Storage
                      </label>
                    </div>
                    <div>
                      <span
                        className={`error-text ${errors.service_type ? "d-inline" : "d-none"
                          }`}
                      >
                        {errors.service_type &&
                          errors.service_type.type === "required" &&
                          "Required."}
                      </span>
                    </div>
                  </div>
                  <div className="form-group text-center">
                    <button
                      type="submit"
                      id="submit_lead_btn"
                      disabled={status === "in-progress" ? true : false}
                      className="btn text-white w-100"
                    >
                      {status === "in-progress" ? "Submitting..." : "Claim Now"}
                    </button>
                  </div>
                  <div class="content-text">
                    <img
                      src={
                        config.customerPortal + "/assets/images/home/shield.png"
                      }
                      alt=""
                      width="20"
                      height="20"
                      class="img-fluid"
                    />{" "}
                    Trusted by more than 20,000 customers.{" "}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
